import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';

type PickControlSlate = {
  picks?: unknown[] | null;
  isMissingPicks?: boolean;
};

export const getCanMakePicks = (entry?: { isPickController?: boolean }): boolean =>
  entry?.isPickController !== false;

export const getVisibleUserEntriesCount = (contest?: Pick<FullContest, 'entries'>): number =>
  contest?.entries?.user_any_stake ?? contest?.entries?.user ?? 0;

export const getIsSlateMissingPicks = (
  slate?: PickControlSlate,
  canMakePicks = true
): boolean | undefined =>
  canMakePicks ? !slate?.picks?.filter(Boolean).length : slate?.isMissingPicks;

export const getHasHiddenPicks = (slate?: PickControlSlate, canMakePicks = true): boolean =>
  !canMakePicks && slate?.isMissingPicks === false && !slate.picks?.some(Boolean);
